import { isArray, isString } from 'lodash';

export const isOptionValueEnabled = <T>(
  optionValues: (T | undefined)[] | undefined,
  optionValue: T | undefined
) =>
  (optionValue &&
    !isString(optionValues) &&
    isArray(optionValues) &&
    optionValues?.includes(optionValue)) ||
  false;

export const toogleOptionValue = <T>(
  optionValues: (T | undefined)[] | undefined,
  optionValue: T | undefined
): (T | undefined)[] | undefined => {
  let result = !isString(optionValues) && isArray(optionValues) ? [...optionValues] : [];

  if (isOptionValueEnabled(optionValues, optionValue)) {
    result = result.filter((tl) => tl !== optionValue);
  } else {
    !!optionValue && result.push(optionValue);
  }

  return result.length ? result.sort() : undefined;
};
